// AUTO-GENERATED by buildchain/scripts/generate-fa-icons.mjs — do not edit.
// Regenerated on every build/dev via the prebuild/predev npm hooks. Holds the
// FontAwesome icon subset actually reachable from the iconFa field options, the
// template icon classes and the brand-icon macro (BC-40).

import {
    faAirplay,
    faAnchorCircleCheck,
    faAngleLeft,
    faAngleRight,
    faSortAlphaDown,
    faSortAlt,
    faSortSizeDown,
    faArrowRightToCity,
    faArrowTrendDown,
    faArrowTrendUp,
    faSortNumericUp,
    faSortNumericUpAlt,
    faSortAlphaUp,
    faArrowUpFromBracket,
    faArrowUpRightAndArrowDownLeftFromCenter,
    faArrowsSpin,
    faArrowsToEye,
    faAt,
    faBalloon,
    faBallot,
    faBarcode,
    faTasksAlt,
    faBarsSort,
    faStream,
    faShoppingBasketAlt,
    faBatteryFull,
    faBatteryHalf,
    faBatterySlash,
    faBatteryThreeQuarters,
    faBed,
    faBedBunk,
    faBedEmpty,
    faBedFront,
    faBellSlash,
    faBells,
    faBenchTree,
    faBinBottles,
    faBinBottlesRecycle,
    faBinRecycle,
    faBinoculars,
    faBiohazard,
    faBlanketFire,
    faBlinds,
    faWallBrick,
    faZap,
    faBoltAuto,
    faBoltLightning,
    faBoltSlash,
    faBook,
    faBooks,
    faBoot,
    faBootHeeled,
    faSoup,
    faBox,
    faBoxOpen,
    faBoxOpenFull,
    faBoxTissue,
    faBoxesPacking,
    faBoxesStacked,
    faBrakeWarning,
    faBreadSlice,
    faBridge,
    faBridgeWater,
    faBriefcaseArrowRight,
    faBriefcaseBlank,
    faBriefcaseMedical,
    faBrowser,
    faBuilding,
    faBuildingCircleArrowRight,
    faBuildingCircleCheck,
    faBuildingCircleExclamation,
    faBuildingCircleXmark,
    faUniversity,
    faBuildingFlag,
    faBuildingLock,
    faBuildingMagnifyingGlass,
    faBuildingMemo,
    faBuildingNgo,
    faBuildingShield,
    faBuildingUn,
    faBuildingUser,
    faBuildingWheat,
    faBuildings,
    faBulldozer,
    faBus,
    faBusinessTime,
    faTram,
    faCalculator,
    faCalendarDays,
    faCalendarNote,
    faCalendarStar,
    faCalendars,
    faVideoHandheld,
    faCctv,
    faCameraRotate,
    faCameraSecurity,
    faCameraSlash,
    faCapsules,
    faCar,
    faCarBattery,
    faCarBolt,
    faCarBuilding,
    faCarCircleBolt,
    faCarGarage,
    faCarMirrors,
    faCarTilt,
    faCarWrench,
    faCarpool,
    faDollyFlatbedAlt,
    faDollyFlatbedEmpty,
    faLuggageCart,
    faCartMinus,
    faCartShoppingFast,
    faCashRegister,
    faChairOffice,
    faChargingStation,
    faChartCandlestick,
    faChartDiagram,
    faChartFft,
    faChartLineUp,
    faChartLineUpDown,
    faChartNetwork,
    faPieChart,
    faChartPieSimple,
    faChartScatterBubble,
    faChartSimple,
    faChartSine,
    faChartTreeMap,
    faUserChart,
    faChartWaterfall,
    faChildren,
    faCircle1,
    faCircle2,
    faCircle3,
    faCircle4,
    faCircle5,
    faCircle6,
    faCircleCheck,
    faInfoCircle,
    faCircleWifi,
    faXmarkCircle,
    faCity,
    faHistory,
    faClockThree,
    faFog,
    faCloudHail,
    faClouds,
    faCoins,
    faContainerStorage,
    faConveyorBelt,
    faConveyorBeltArm,
    faConveyorBeltBoxes,
    faCreditCardFront,
    faDesktopAlt,
    faDialMedLow,
    faDisplayChartUp,
    faDollyBox,
    faDollyEmpty,
    faDoorClosed,
    faDrone,
    faDryer,
    faDumbbell,
    faDumpster,
    faGlobeAmericas,
    faGlobeEurope,
    faEngine,
    faEnvelopeOpenText,
    faEnvelopes,
    faEscalator,
    faLaugh,
    faFaceShush,
    faFanTable,
    faFaucet,
    faFileCheck,
    faFileText,
    faFilmSimple,
    faFilter,
    faFingerprint,
    faForklift,
    faFort,
    faGasPump,
    faGear,
    faGears,
    faGift,
    faGlobe,
    faHandshakeSimple,
    faHatChef,
    faHeadSideBrain,
    faHeadSideMask,
    faHeadphonesSimple,
    faHeadset,
    faHillAvalanche,
    faHillRockslide,
    faHospitalUser,
    faHospitals,
    faHourglassEmpty,
    faHourglassClock,
    faHourglassEnd,
    faHourglassHalf,
    faHouseBlank,
    faHouseBuilding,
    faHouseChimney,
    faHouseChimneyBlank,
    faHouseDay,
    faHouseFloodWater,
    faHouseFloodWaterCircleArrowRight,
    faHouseHeart,
    faHouseMedicalCircleCheck,
    faHouseTree,
    faHouseTurret,
    faImagePolaroidUser,
    faPortrait,
    faImageSlash,
    faImages,
    faInboxIn,
    faInboxOut,
    faInboxes,
    faIndustry,
    faInfinity,
    faInfo,
    faKitMedical,
    faLampDesk,
    faLampFloor,
    faLampStreet,
    faLandmark,
    faLaptop,
    faLaptopFile,
    faLeaf,
    faLeafOak,
    faLeafyGreen,
    faLeftFromBracket,
    faLightCeiling,
    faLightEmergency,
    faLightbulbOn,
    faLightsHoliday,
    faLineColumns,
    faLinkSimple,
    faLinkSimpleSlash,
    faTasks,
    faListDropdown,
    faListTree,
    faListUl,
    faLocationArrowUp,
    faMapMarkerCheck,
    faMapMarkerAlt,
    faMapMarker,
    faLocationPinLock,
    faLock,
    faLockKeyhole,
    faLockOpen,
    faLoveseat,
    faSearchMinus,
    faMap,
    faMapMarked,
    faMapMarkedAlt,
    faMaskFace,
    faTheaterMasks,
    faMedal,
    faMemo,
    faMemoCircleCheck,
    faMemoCircleInfo,
    faMerge,
    faMessage,
    faMessageExclamation,
    faMessageHeart,
    faMessageImage,
    faMessageLines,
    faMessages,
    faMessagesQuestion,
    faMeter,
    faMeterBolt,
    faMicrochipAi,
    faMicrophone,
    faMicrowave,
    faMoneyBillsSimple,
    faMoneyCheckDollar,
    faMoneyFromBracket,
    faMonitorWaveform,
    faMoon,
    faMoped,
    faMotorcycle,
    faMountainCity,
    faMountainSun,
    faMountains,
    faMugTea,
    faMusic,
    faNetworkWired,
    faNotebook,
    faObjectsAlignBottom,
    faObjectsAlignCenterHorizontal,
    faObjectsAlignCenterVertical,
    faObjectsAlignLeft,
    faObjectsAlignRight,
    faObjectsColumn,
    faOilCanDrip,
    faOilWell,
    faOutlet,
    faOven,
    faPallet,
    faPalletBox,
    faPalletBoxes,
    faPaperPlane,
    faPaperclipVertical,
    faPassport,
    faPause,
    faPenNib,
    faPeopleRoof,
    faPersonDollyEmpty,
    faPersonWalkingLuggage,
    faPhoneIntercom,
    faPhoneOffice,
    faPhoneSlash,
    faVolumeControlPhone,
    faPlane,
    faPlaneArrival,
    faPlaneDeparture,
    faPlaneEngines,
    faPlanetMoon,
    faPlay,
    faPlugCircleBolt,
    faPlugCircleCheck,
    faPresentationScreen,
    faQuotes,
    faRadiation,
    faRadio,
    faRadioTuner,
    faRampLoading,
    faRectanglesMixed,
    faRecycle,
    faRepeat,
    faRestroomSimple,
    faRoad,
    faRoadBarrier,
    faRoadBridge,
    faRoadLock,
    faRobotAstromech,
    faRocketLaunch,
    faRouter,
    faRulerCombined,
    faRulerHorizontal,
    faScaleUnbalancedFlip,
    faScannerKeyboard,
    faSchool,
    faSchoolFlag,
    faSdCard,
    faSdCards,
    faSprout,
    faSensorSmoke,
    faServer,
    faShelves,
    faShieldHalved,
    faShip,
    faShirtLongSleeve,
    faShoePrints,
    faStoreAlt,
    faShovel,
    faShower,
    faSignPost,
    faSignPosts,
    faSignalBarsStrong,
    faSignalSlash,
    faSitemap,
    faSlider,
    faSlidersSimple,
    faSmog,
    faSmoking,
    faSnowBlowing,
    faSnowflake,
    faSolarPanel,
    faSolarSystem,
    faSparkle,
    faSpeaker,
    faSpellCheck,
    faSplit,
    faSprayCan,
    faSprinklerCeiling,
    faSquare0,
    faSquareInfo,
    faStairs,
    faStamp,
    faStapler,
    faStar,
    faStarOfLife,
    faStoreLock,
    faStoreSlash,
    faSun,
    faTh,
    faThLarge,
    faTableCellsRowLock,
    faTableCellsRowUnlock,
    faTableLayout,
    faTablePicnic,
    faTableTennisPaddleBall,
    faTape,
    faTaxi,
    faThermometerFull,
    faThermometerHalf,
    faTent,
    faTentDoublePeak,
    faTicketsSimple,
    faTimer,
    faToggleLargeOn,
    faToilet,
    faToiletPaperBlank,
    faToolbox,
    faTowerBroadcast,
    faTowerCell,
    faTractor,
    faTrafficCone,
    faTrafficLightGo,
    faTrailer,
    faTrainSubway,
    faTrainTrack,
    faTrainTram,
    faTrainTunnel,
    faTrash,
    faTrashCan,
    faTrashList,
    faTreeCity,
    faTreeDeciduous,
    faTrowel,
    faTruck,
    faTruckArrowRight,
    faTruckBolt,
    faTruckClock,
    faTruckContainer,
    faTruckContainerEmpty,
    faTruckFast,
    faTruckField,
    faTruckFire,
    faTruckFront,
    faTruckLadder,
    faTruckMedical,
    faTruckMoving,
    faTruckPlane,
    faTruckTow,
    faTruckUtensils,
    faTurntable,
    faTvAlt,
    faTvMusic,
    faUmbrella,
    faUpToLine,
    faUsbDrive,
    faUsersGear,
    faUsersLine,
    faVault,
    faVials,
    faWallet,
    faWarehouse,
    faWarehouseFull,
    faWashingMachine,
    faWatch,
    faWater,
    faWaterLadder,
    faWave,
    faWeightHanging,
    faWheatAwn,
    faWheatAwnCircleExclamation,
    faWheelchair,
    faWindTurbine,
    faWindWarning,
    faWindowFrame,
    faWindsock,
} from '@awesome.me/kit-bc84d927de/icons/classic/regular'

import {
    faArrowRight,
    faArrowUpRight,
    faCaretRight,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faPodcast,
} from '@awesome.me/kit-bc84d927de/icons/classic/solid'

import {
    faFacebook,
    faInstagram,
    faLinkedinIn,
    faSoundcloud,
    faSpotify,
    faXTwitter,
    faYoutube,
} from '@awesome.me/kit-bc84d927de/icons/classic/brands'

import {
    faIconAddedValue,
    faIconAtom,
    faIconCrane,
    faIconGreenPower,
    faIconLowerCo2,
    faIconNoFossilFuels,
    faIconSolarPanel,
    faIconWarehouse,
} from '@awesome.me/kit-bc84d927de/icons/kit/custom'

export const icons = [
    faAirplay,
    faAnchorCircleCheck,
    faAngleLeft,
    faAngleRight,
    faSortAlphaDown,
    faSortAlt,
    faSortSizeDown,
    faArrowRightToCity,
    faArrowTrendDown,
    faArrowTrendUp,
    faSortNumericUp,
    faSortNumericUpAlt,
    faSortAlphaUp,
    faArrowUpFromBracket,
    faArrowUpRightAndArrowDownLeftFromCenter,
    faArrowsSpin,
    faArrowsToEye,
    faAt,
    faBalloon,
    faBallot,
    faBarcode,
    faTasksAlt,
    faBarsSort,
    faStream,
    faShoppingBasketAlt,
    faBatteryFull,
    faBatteryHalf,
    faBatterySlash,
    faBatteryThreeQuarters,
    faBed,
    faBedBunk,
    faBedEmpty,
    faBedFront,
    faBellSlash,
    faBells,
    faBenchTree,
    faBinBottles,
    faBinBottlesRecycle,
    faBinRecycle,
    faBinoculars,
    faBiohazard,
    faBlanketFire,
    faBlinds,
    faWallBrick,
    faZap,
    faBoltAuto,
    faBoltLightning,
    faBoltSlash,
    faBook,
    faBooks,
    faBoot,
    faBootHeeled,
    faSoup,
    faBox,
    faBoxOpen,
    faBoxOpenFull,
    faBoxTissue,
    faBoxesPacking,
    faBoxesStacked,
    faBrakeWarning,
    faBreadSlice,
    faBridge,
    faBridgeWater,
    faBriefcaseArrowRight,
    faBriefcaseBlank,
    faBriefcaseMedical,
    faBrowser,
    faBuilding,
    faBuildingCircleArrowRight,
    faBuildingCircleCheck,
    faBuildingCircleExclamation,
    faBuildingCircleXmark,
    faUniversity,
    faBuildingFlag,
    faBuildingLock,
    faBuildingMagnifyingGlass,
    faBuildingMemo,
    faBuildingNgo,
    faBuildingShield,
    faBuildingUn,
    faBuildingUser,
    faBuildingWheat,
    faBuildings,
    faBulldozer,
    faBus,
    faBusinessTime,
    faTram,
    faCalculator,
    faCalendarDays,
    faCalendarNote,
    faCalendarStar,
    faCalendars,
    faVideoHandheld,
    faCctv,
    faCameraRotate,
    faCameraSecurity,
    faCameraSlash,
    faCapsules,
    faCar,
    faCarBattery,
    faCarBolt,
    faCarBuilding,
    faCarCircleBolt,
    faCarGarage,
    faCarMirrors,
    faCarTilt,
    faCarWrench,
    faCarpool,
    faDollyFlatbedAlt,
    faDollyFlatbedEmpty,
    faLuggageCart,
    faCartMinus,
    faCartShoppingFast,
    faCashRegister,
    faChairOffice,
    faChargingStation,
    faChartCandlestick,
    faChartDiagram,
    faChartFft,
    faChartLineUp,
    faChartLineUpDown,
    faChartNetwork,
    faPieChart,
    faChartPieSimple,
    faChartScatterBubble,
    faChartSimple,
    faChartSine,
    faChartTreeMap,
    faUserChart,
    faChartWaterfall,
    faChildren,
    faCircle1,
    faCircle2,
    faCircle3,
    faCircle4,
    faCircle5,
    faCircle6,
    faCircleCheck,
    faInfoCircle,
    faCircleWifi,
    faXmarkCircle,
    faCity,
    faHistory,
    faClockThree,
    faFog,
    faCloudHail,
    faClouds,
    faCoins,
    faContainerStorage,
    faConveyorBelt,
    faConveyorBeltArm,
    faConveyorBeltBoxes,
    faCreditCardFront,
    faDesktopAlt,
    faDialMedLow,
    faDisplayChartUp,
    faDollyBox,
    faDollyEmpty,
    faDoorClosed,
    faDrone,
    faDryer,
    faDumbbell,
    faDumpster,
    faGlobeAmericas,
    faGlobeEurope,
    faEngine,
    faEnvelopeOpenText,
    faEnvelopes,
    faEscalator,
    faLaugh,
    faFaceShush,
    faFanTable,
    faFaucet,
    faFileCheck,
    faFileText,
    faFilmSimple,
    faFilter,
    faFingerprint,
    faForklift,
    faFort,
    faGasPump,
    faGear,
    faGears,
    faGift,
    faGlobe,
    faHandshakeSimple,
    faHatChef,
    faHeadSideBrain,
    faHeadSideMask,
    faHeadphonesSimple,
    faHeadset,
    faHillAvalanche,
    faHillRockslide,
    faHospitalUser,
    faHospitals,
    faHourglassEmpty,
    faHourglassClock,
    faHourglassEnd,
    faHourglassHalf,
    faHouseBlank,
    faHouseBuilding,
    faHouseChimney,
    faHouseChimneyBlank,
    faHouseDay,
    faHouseFloodWater,
    faHouseFloodWaterCircleArrowRight,
    faHouseHeart,
    faHouseMedicalCircleCheck,
    faHouseTree,
    faHouseTurret,
    faImagePolaroidUser,
    faPortrait,
    faImageSlash,
    faImages,
    faInboxIn,
    faInboxOut,
    faInboxes,
    faIndustry,
    faInfinity,
    faInfo,
    faKitMedical,
    faLampDesk,
    faLampFloor,
    faLampStreet,
    faLandmark,
    faLaptop,
    faLaptopFile,
    faLeaf,
    faLeafOak,
    faLeafyGreen,
    faLeftFromBracket,
    faLightCeiling,
    faLightEmergency,
    faLightbulbOn,
    faLightsHoliday,
    faLineColumns,
    faLinkSimple,
    faLinkSimpleSlash,
    faTasks,
    faListDropdown,
    faListTree,
    faListUl,
    faLocationArrowUp,
    faMapMarkerCheck,
    faMapMarkerAlt,
    faMapMarker,
    faLocationPinLock,
    faLock,
    faLockKeyhole,
    faLockOpen,
    faLoveseat,
    faSearchMinus,
    faMap,
    faMapMarked,
    faMapMarkedAlt,
    faMaskFace,
    faTheaterMasks,
    faMedal,
    faMemo,
    faMemoCircleCheck,
    faMemoCircleInfo,
    faMerge,
    faMessage,
    faMessageExclamation,
    faMessageHeart,
    faMessageImage,
    faMessageLines,
    faMessages,
    faMessagesQuestion,
    faMeter,
    faMeterBolt,
    faMicrochipAi,
    faMicrophone,
    faMicrowave,
    faMoneyBillsSimple,
    faMoneyCheckDollar,
    faMoneyFromBracket,
    faMonitorWaveform,
    faMoon,
    faMoped,
    faMotorcycle,
    faMountainCity,
    faMountainSun,
    faMountains,
    faMugTea,
    faMusic,
    faNetworkWired,
    faNotebook,
    faObjectsAlignBottom,
    faObjectsAlignCenterHorizontal,
    faObjectsAlignCenterVertical,
    faObjectsAlignLeft,
    faObjectsAlignRight,
    faObjectsColumn,
    faOilCanDrip,
    faOilWell,
    faOutlet,
    faOven,
    faPallet,
    faPalletBox,
    faPalletBoxes,
    faPaperPlane,
    faPaperclipVertical,
    faPassport,
    faPause,
    faPenNib,
    faPeopleRoof,
    faPersonDollyEmpty,
    faPersonWalkingLuggage,
    faPhoneIntercom,
    faPhoneOffice,
    faPhoneSlash,
    faVolumeControlPhone,
    faPlane,
    faPlaneArrival,
    faPlaneDeparture,
    faPlaneEngines,
    faPlanetMoon,
    faPlay,
    faPlugCircleBolt,
    faPlugCircleCheck,
    faPresentationScreen,
    faQuotes,
    faRadiation,
    faRadio,
    faRadioTuner,
    faRampLoading,
    faRectanglesMixed,
    faRecycle,
    faRepeat,
    faRestroomSimple,
    faRoad,
    faRoadBarrier,
    faRoadBridge,
    faRoadLock,
    faRobotAstromech,
    faRocketLaunch,
    faRouter,
    faRulerCombined,
    faRulerHorizontal,
    faScaleUnbalancedFlip,
    faScannerKeyboard,
    faSchool,
    faSchoolFlag,
    faSdCard,
    faSdCards,
    faSprout,
    faSensorSmoke,
    faServer,
    faShelves,
    faShieldHalved,
    faShip,
    faShirtLongSleeve,
    faShoePrints,
    faStoreAlt,
    faShovel,
    faShower,
    faSignPost,
    faSignPosts,
    faSignalBarsStrong,
    faSignalSlash,
    faSitemap,
    faSlider,
    faSlidersSimple,
    faSmog,
    faSmoking,
    faSnowBlowing,
    faSnowflake,
    faSolarPanel,
    faSolarSystem,
    faSparkle,
    faSpeaker,
    faSpellCheck,
    faSplit,
    faSprayCan,
    faSprinklerCeiling,
    faSquare0,
    faSquareInfo,
    faStairs,
    faStamp,
    faStapler,
    faStar,
    faStarOfLife,
    faStoreLock,
    faStoreSlash,
    faSun,
    faTh,
    faThLarge,
    faTableCellsRowLock,
    faTableCellsRowUnlock,
    faTableLayout,
    faTablePicnic,
    faTableTennisPaddleBall,
    faTape,
    faTaxi,
    faThermometerFull,
    faThermometerHalf,
    faTent,
    faTentDoublePeak,
    faTicketsSimple,
    faTimer,
    faToggleLargeOn,
    faToilet,
    faToiletPaperBlank,
    faToolbox,
    faTowerBroadcast,
    faTowerCell,
    faTractor,
    faTrafficCone,
    faTrafficLightGo,
    faTrailer,
    faTrainSubway,
    faTrainTrack,
    faTrainTram,
    faTrainTunnel,
    faTrash,
    faTrashCan,
    faTrashList,
    faTreeCity,
    faTreeDeciduous,
    faTrowel,
    faTruck,
    faTruckArrowRight,
    faTruckBolt,
    faTruckClock,
    faTruckContainer,
    faTruckContainerEmpty,
    faTruckFast,
    faTruckField,
    faTruckFire,
    faTruckFront,
    faTruckLadder,
    faTruckMedical,
    faTruckMoving,
    faTruckPlane,
    faTruckTow,
    faTruckUtensils,
    faTurntable,
    faTvAlt,
    faTvMusic,
    faUmbrella,
    faUpToLine,
    faUsbDrive,
    faUsersGear,
    faUsersLine,
    faVault,
    faVials,
    faWallet,
    faWarehouse,
    faWarehouseFull,
    faWashingMachine,
    faWatch,
    faWater,
    faWaterLadder,
    faWave,
    faWeightHanging,
    faWheatAwn,
    faWheatAwnCircleExclamation,
    faWheelchair,
    faWindTurbine,
    faWindWarning,
    faWindowFrame,
    faWindsock,
    faArrowRight,
    faArrowUpRight,
    faCaretRight,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faPodcast,
    faFacebook,
    faInstagram,
    faLinkedinIn,
    faSoundcloud,
    faSpotify,
    faXTwitter,
    faYoutube,
    faIconAddedValue,
    faIconAtom,
    faIconCrane,
    faIconGreenPower,
    faIconLowerCo2,
    faIconNoFossilFuels,
    faIconSolarPanel,
    faIconWarehouse,
];
